/**
 * Created For: 终端查询相关接口
 * Author: chenLiYan.
 * Date: 2018/11/30 0030 16:17.
 */
import request from '@/utils/request'

export function getClientType (params) { // 导出流向明细列表
  return request({
    url: '/v1/client-type/list',
    method: 'get',
    params
  })
}
// 分页查询客户终端
export function asyncSearchClientPage (params) {
  // params:
  // clientName,clientType,cover(是否覆盖),name(药品名称),spec(药品规格),townshipCode,tradingCompany
  // provinceCode,cityCode,districtCode，villageCode, startTime,endTime，limit(10),page(1)
  return request({
    url: '/v1/adb/sca_client/search/page',
    data: params,
    method: 'post'
  })
}
// 查询客户终端地图坐标信息
export function asyncSearchClientMarker (params) {
  // params:
  // clientName,clientType,cover(是否覆盖),name(药品名称),spec(药品规格),townshipCode,tradingCompany
  // provinceCode,cityCode,districtCode，villageCode, startTime,endTime
  return request({
    url: '/v1/adb/sca_client/search',
    data: params,
    method: 'post'
  })
}

// 查询具体客户终端详细信息
export function asyncGetClientInfo (clientId) {
  return request({
    url: '/v1/sca_client/detail/' + clientId,
    method: 'get'
  })
}
// 获取当前统计数据最大月份
export function asyncGetMaxTime (data) {
  return request({
    // url: '/v1/sca_client_order/time/regionSameScreen?sources=publish,ddi,PUBLISH,DDI',
    url: '/v1/flow-time',
    method: 'post',
    data
  })
}
